module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABLCAYAAACx1u2DAAAAFklEQVQYlWN49+7dfyYGBgaGUYKOBADwBwReyx5ihwAAAABJRU5ErkJggg=="